module.exports = __webpack_public_path__ + "static/media/tab-10-image-2.16be4bba.png";